import { Button } from '@/components/UI/Common/Admin/Button';
import { Input } from '@/components/UI/Common/Admin/Input';
import { applicationGroupScheme } from '@/config/validations';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import z from 'zod';

export type FormData = z.infer<typeof applicationGroupScheme>;

export const Form = ({
  formData,
  onSubmit,
  onDelete,
}: {
  onSubmit: (data: FormData) => void;
  onDelete?: VoidFunction;
  formData?: Partial<FormData>;
}) => {
  const initialFormState = formData
    ? formData
    : {
        title: '',
        sort: 1,
      };

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid },
    reset,
  } = useForm<FormData>({
    resolver: zodResolver(applicationGroupScheme),
    defaultValues: initialFormState,
    mode: 'onChange',
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="grid gap-4">
      <Input error={errors.title?.message} label="Название" required {...register('title')} />
      <Input
        error={errors.sort?.message}
        label="Сортировка"
        required
        type="number"
        min={1}
        {...register('sort', { valueAsNumber: true })}
      />

      <div className="flex justify-end gap-4">
        {onDelete && (
          <Button variant="danger" onClick={onDelete} type="button">
            Удалить
          </Button>
        )}
        <Button variant="secondary" disabled={!isDirty} onClick={() => reset()} type="button">
          Сбросить
        </Button>
        <Button disabled={!isValid || !isDirty} type="submit">
          Сохранить
        </Button>
      </div>
    </form>
  );
};
